module.exports = __webpack_public_path__ + "static/agentesLogo-51702de18365194e5fd51de3d9c14787.svg";